import { Button as ButtonValue } from "@mui/material";
import React from "react";
import { basic } from '../../../themes/basic';
const ButtonTwo = (props) => {
  return (
    <ButtonValue
      variant="contained"
      sx={{
        marginRight: 2,
        height: "37px",
        fontSize: basic.buttonFontSize,        
        //filter: "drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.25))",
        borderRadius: "8px",
        color: basic.colorWhite,
        fontWeight: 500,
        minWidth: "83px",
        textTransform: "none",
        fontFamily:basic.fontFamily,
        bgcolor: basic.logoGreyColor,
        boxShadow:"none",
        ":hover": {
          bgcolor: basic.greenColor,
          opacity:"0.8",
          color: basic.colorWhite,
          iconcolor: basic.greenColor,
          boxShadow:"none",
        },
      }}
      {...props}
    >
      {props.children}
    </ButtonValue>
  );
};

export default ButtonTwo;
